// extracted by mini-css-extract-plugin
module.exports = {"Banner":"UpToDateBanner_Banner__7VIY6","BannerInner":"UpToDateBanner_BannerInner__8Ottn"};